import { render, staticRenderFns } from "./C-Footer.vue?vue&type=template&id=068f26e6&scoped=true&"
import script from "./C-Footer.vue?vue&type=script&lang=js&"
export * from "./C-Footer.vue?vue&type=script&lang=js&"
import style0 from "./C-Footer.vue?vue&type=style&index=0&id=068f26e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f26e6",
  null
  
)

export default component.exports